import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';

export class Doug extends Lit3formBlock {
  static get characterName() {
    return 'doug';
  }

  static get characterProperties() {
    return {
      header: { type: String },
      description: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid doug-layout">
          ${this.headerText
            ? html`
                <h2 class="header">${unsafeHTML(this.headerText)}</h2>
              `
            : ``}
          ${this.descriptionText
            ? html`
                <p class="description details-row">
                  ${unsafeHTML(this.descriptionText)}
                </p>
              `
            : ``}
          <span class="images" id="doug-images">
            ${this.imagesArr.map((i, index) => this.imageHTML(i[1], index))}
          </span>
          <span
            class="arrow left-arrow"
            @click="${() => this.sideScroll('left')}"
          >
            <img src="/static/icons/SVG/arrow-black-5x10.svg" />
          </span>
          <span
            class="arrow right-arrow"
            @click="${() => this.sideScroll('right')}"
          >
            <img src="/static/icons/SVG/arrow-black-5x10.svg" />
          </span>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  imageHTML(image, index) {
    return !!image.description
      ? html`
          <div class="image-wrapper">
            <a
              class="image download-cursor"
              href=${this.imageHref(image)}
              rel="noopener"
              id=${`image-index-${index}`}
            >
              <img src=${this.imageUrl(image)} />
            </a>
            <p class="image-description font-size-small">
              ${unsafeHTML(this.withLineBreaks(image.description))}
            </p>
          </div>
        `
      : html`
          <div class="image-wrapper">
            <div class="image">
              <img src=${this.imageUrl(image)} />
            </div>
          </div>
        `;
  }

  textSectionsHTML(image) {
    return image.description?.length > 0
      ? html`
          <div class="text-sections-wrapper">
            ${image.description.map(section => {
              return html`
                <span class="text-section">
                  <p>
                    <b>${unsafeHTML(this.withLineBreaks(section.heading))}</b>
                    ${section.paragraphs.map(paragraph => {
                      return unsafeHTML(this.withLineBreaks(paragraph));
                    })}
                  </p>
                </span>
              `;
            })}
          </div>
        `
      : html``;
  }

  sideScroll(direction) {
    const wrapperElement = this.shadowRoot.getElementById('doug-images');
    let scrollAmount = 0;
    const step = 40;
    const distance = wrapperElement.getBoundingClientRect().width;
    const slideTimer = setInterval(function() {
      direction === 'left'
        ? (wrapperElement.scrollLeft -= step)
        : (wrapperElement.scrollLeft += step);
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, 10);
  }

  imageHref(image) {
    return image.url ? image.url : image.full_resolution_src;
  }

  imageUrl(image) {
    return this.imagebossUrl(image.src, null, 400);
  }

  get imagesArr() {
    return !this.content.images || this.content.images.length === 0
      ? []
      : this.content.images;
  }

  get headerText() {
    return this.withLineBreaks(this.content.header) || '';
  }

  get descriptionText() {
    return this.withLineBreaks(this.content.description) || '';
  }
}
Doug.defineElement();
